import type { IToggle } from 'unleash-proxy-client';

import type { AppState } from 'types/app';
import {
  FEATURE_ENABLED_VARIANT_NAME_TREATMENT,
  FEATURE_HOME_PAGE_KRATOS,
  FEATURE_LANDING_PAGE_KRATOS,
  FEATURE_MAFIA_AKAMAI,
  FEATURE_MARTY_CLIENT_RENDER,
  FEATURE_PDP_KRATOS
} from 'constants/features';

export const selectUnleashToggle = (feature: string, state: AppState): IToggle | undefined =>
  (state.unleash?.toggles || []).find((t: IToggle) => t.name === feature);

export const selectABTestEnabled = (testName: string, state: AppState, treatmentValue = '1') =>
  selectUnleashVariantByPayload(testName, state) === treatmentValue;

export const selectIsFeatureMafiaAkamai = (state: AppState) => Boolean(selectUnleashToggle(FEATURE_MAFIA_AKAMAI, state)?.enabled);

export const selectIsFeatureMartyClientRender = (state: AppState) => Boolean(selectUnleashToggle(FEATURE_MARTY_CLIENT_RENDER, state)?.enabled);

export const selectUnleashVariantByPayload = (feature: string, state: AppState) => selectUnleashToggle(feature, state)?.variant.payload?.value;

export const selectLandingPageKratosVariant = (state: AppState) => {
  const variant = selectUnleashToggle(FEATURE_LANDING_PAGE_KRATOS, state)?.variant?.name;
  return variant || 'disabled';
};

export const selectIsHomePageExperiment = (state: AppState) => {
  const variant = selectUnleashToggle(FEATURE_HOME_PAGE_KRATOS, state)?.variant?.name;
  return variant === FEATURE_ENABLED_VARIANT_NAME_TREATMENT;
};

export const selectPdpKratosVariant = (state: AppState) => {
  const variant = selectUnleashToggle(FEATURE_PDP_KRATOS, state)?.variant?.name;
  return variant || 'control';
};
